import React from "react";
import * as agent from "../agent";
import { connect } from "react-redux";
import { Field, formValueSelector, reduxForm, change } from "redux-form";
import { normalizeMoney, required, formatDate, validateDate, normalizeRate } from "../utility";
import { Masks, Credit, Transaction } from "../constants/enums";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import throttle from "lodash/throttle";
import { FormattedDate, FormattedNumber } from "react-intl";
import InputAdornment from '@material-ui/core/InputAdornment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import MaterialDatePicker from './MaterialDatePicker';
import TextField from '@material-ui/core/TextField';
import Preloader from './Preloader';
import MaterialAutocomplete from "./MaterialAutocomplete";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import Fade from '@material-ui/core/Fade';
import transactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import InnerLink from './InnerLink';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableFooter from '@material-ui/core/TableFooter';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from "./TablePaginationActions";
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Typography from '@material-ui/core/Typography';

const aliases = {
    "CREDIT": Transaction.OperationSignAliases,
    "DEBIT": Transaction.OperationAttractAliases
};

const TransactionForm = connect(
    (state, props) => {
        const { operations, inputSum } = props;
        const inputType = formValueSelector("new-credit-form")(state, "type");
        const inputSide = formValueSelector("new-credit-form")(state, "side");

        const foundOperation = operations.find(o => (inputType && inputSide) ? o.alias === aliases[inputSide][inputType] : false) || {};
        const inputDepartment = formValueSelector("new-credit-form")(state, "department");
        const inputCounterparty = formValueSelector("new-credit-form")(state, "counterparty");
        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            initialValues: {
                paymentDate: formatDate(new Date()),
                manager: state.common.user.id,
                department: inputDepartment,
                counterparty: inputCounterparty,
                operation: foundOperation._id,
                sum: inputSum,
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

const addCreditForm = ({
    transactions,
    addTransaction,
    deleteTransaction,
    accounts,
    accountsLoaded,
    operations,
    operationsLoaded,
    showModal,
    isAdmin,
    handleClick,
    handleClose,
    inputSum,
    inputType,
    inputSide,
    companies,
    companiesLoaded,
    counterparties,
    counterpartiesLoaded,
    managers,
    managersLoaded,
    invalid,
    handleTypeChange,
    onCreditCreate,
    handleSubmit }) => {
    const transactionsSum = transactions.reduce((p, n) => p + Number(`${n.sum}`.replace(/\s/g,``)), 0);
    const creditType = Credit.Types[inputType];
    const allowedOperations = inputSide && inputType ? [aliases[inputSide][inputType]] : [];
    const submitDisabled = transactionsSum !== Number(`${inputSum}`.replace(/\s/g,``));

    return (
        <form className="common-form">
            <Field name="type"
                   select
                   validate={required}
                   onChange={handleTypeChange}
                   component={MaterialTextField}
                   label="Тип" >
               {Object.keys(Credit.Types).map((t, i) => {
                   return <MenuItem key={i} value={t}>{Credit.Types[t]}</MenuItem>
               })}
            </Field>
            <Field name="side"
                   select
                   validate={required}
                   disabled={inputType === "CREDIT"}
                   component={MaterialTextField}
                   label="Сторона учета" >
               {Object.keys(Credit.Sides).map((s, j) => {
                   return <MenuItem key={j} value={s}>{Credit.Sides[s]}</MenuItem>
               })}
            </Field>
            <Field name="date"
                   component={MaterialMaskedTextField}
                   disabled={!isAdmin}
                   validate={validateDate}
                   mask={Masks.date}
                   label="Дата" />
            <Field component={MaterialTextField}
                   select
                   name="manager"
                   validate={required}
                   disabled={!managersLoaded}
                   label="Исполнитель">
                {managers.map(({ _id, fullname}, i) => {
                    const [ managerLastname, managerFirstname = "", managerThirdname = "" ] = fullname.split(" ");
                    return <MenuItem key={i} value={_id}>{`${managerLastname} ${managerFirstname[0]}. ${managerThirdname[0]}.`}</MenuItem>
                })}
            </Field>
            <Field name="company"
                   select
                   validate={required}
                   disabled={!companiesLoaded}
                   component={MaterialTextField}
                   label={`Компания${inputSide ? ({"DEBIT": "-займополучатель", "CREDIT": "-займодатель"})[inputSide] : ""}`}>
                {companies.map(({ _id, name}, i) => <MenuItem key={i} value={_id}>{name}</MenuItem>)}
            </Field>
            <Field component={MaterialAutocomplete}
                   name="counterparty"
                   validate={required}
                   formatTextValue={c => `${c.name}`}
                   getInitialValue={agent.Counterparty.getById}
                   getSuggestionsMethod={agent.Counterparty.getByName}
                   label={`Контрагент${inputSide ? ({"DEBIT": "-займодатель", "CREDIT": "-займополучатель"})[inputSide] : ""}`}/>
            <Field component={MaterialTextField}
                   name="duration"
                   validate={required}
                   endAdornment="дн."
                   label="Срок займа" />
            <Field component={MaterialTextField}
                   name="sum"
                   normalize={normalizeMoney}
                   validate={required}
                   format={normalizeMoney}
                   endAdornment="₽"
                   label="Сумма" />
            <Field component={MaterialTextField}
                   name="rate"
                   normalize={normalizeRate}
                   validate={required}
                   endAdornment="%"
                   label="Годовая ставка" />
            <Button type="submit"
                    fullWidth
                    onClick={handleClick}
                    disabled={invalid}
                    color="primary"
                    size="large"
                    variant="contained">К транзакциям</Button>
            {showModal &&
                <Dialog maxWidth={false} open={showModal} onClose={handleClose}>
                    <Paper className="common-paper">
                        <Grid container justify="flex-start" spacing={16}>
                            <Grid item className="common-column">
                                <TransactionForm addTransaction={addTransaction}
                                                 managers={managers}
                                                 managersLoaded={managersLoaded}
                                                 accounts={accounts}
                                                 accountsLoaded={accountsLoaded}
                                                 counterparties={counterparties}
                                                 counterpartiesLoaded={counterpartiesLoaded}
                                                 operations={operations}
                                                 operationsLoaded={operationsLoaded}
                                                 inputSum={inputSum}
                                                 allowedOperations={allowedOperations}
                                                 creditMode={true} />
                            </Grid>
                            <Grid item className="maxwide-column">
                                { transactions.length > 0 ?
                                    <TransactionTable transactions={transactions}
                                                       accounts={accounts}
                                                       counterparties={counterparties}
                                                       operations={operations}
                                                       onTransactionDelete={deleteTransaction} />
                                    :
                                    <Typography>Добавьте транзакцию</Typography>
                                }
                            </Grid>
                        </Grid>
                        <Grid container spacing={16}>
                            <Grid item className="common-column">
                                <Button type="submit"
                                        fullWidth
                                        disabled={submitDisabled}
                                        onClick={handleSubmit(data => onCreditCreate(data))}
                                        size="large"
                                        color="primary"
                                        variant="contained" >{Credit.Types[inputType]} {{"CREDIT": "выдан", "DEBIT": "привлечен"}[inputSide]}</Button>
                            </Grid>
                            <Grid item className="maxwide-column">
                                {submitDisabled && <Typography>Чтобы {{"CREDIT": "выдать", "DEBIT": "привлечь"}[inputSide]} новый {creditType} необходимо: </Typography>}
                                {submitDisabled && <Typography>Провести одну или несколько транзакций на сумму {normalizeMoney(inputSum)} ₽</Typography>}
                                {transactionsSum > inputSum && <Typography style={{ color: "red" }}>Сумма транзакций превышает сумму {{"CREDIT": "выдачи", "DEBIT": "привлечения"}[inputSide]} займа на {normalizeMoney(transactionsSum - inputSum)} ₽. Удалите одну или несколько транзакций</Typography>}
                                {transactionsSum < inputSum && <Typography style={{ color: "red" }}>Cумма {{"CREDIT": "выдачи", "DEBIT": "привлечения"}[inputSide]} займа превышает сумму транзакций на {normalizeMoney(inputSum - transactionsSum)} ₽. Добавьте одну или несколько транзакций</Typography>}
                                <Typography>Вы добавили {transactions.length} транзакций на сумму {normalizeMoney(transactionsSum)} ₽</Typography>
                                {!submitDisabled && <Typography>Cуммы транзакций совпадают. Операция может быть проведена</Typography>}
                            </Grid>
                        </Grid>
                    </Paper>
                </Dialog>
            }
        </form>
)};

const AddCreditForm = connect(
    (state, props) => {
        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            inputType: formValueSelector("new-credit-form")(state, "type"),
            inputSide: formValueSelector("new-credit-form")(state, "side"),
            inputSum: Number(`${formValueSelector("new-credit-form")(state, "sum")}`.replace(/\s/g,``)),
            initialValues: {
                manager: state.common.user.id,
                date: formatDate(new Date()),
            },
        };
    },
    (dispatch, props) => ({
        handleTypeChange: (e) => {
            dispatch(change("new-credit-form", "side", e.target.value === "CREDIT" ? "DEBIT" : "" ));
        }
    })
)(reduxForm({ form: "new-credit-form", enableReinitialize: true })(addCreditForm));

class Credits extends React.Component {

    state = {
        transactions: [],
        accountsLoaded: false,
        accounts: [],
        operationsLoaded: false,
        operations: [],
        companiesLoaded: false,
        companies: [],
        counterpartiesLoaded: false,
        counterparties: [],
        managersLoaded: false,
        managers: [],
        creditsLoaded: false,
        credits: [],
        totalCredits: 0,
        totalCreditsSum: 0,
        currentPage: 0,
        sortedField: "date",
        searchQuery: "",
        startDate: null,
        endDate: new Date(),
        asc: -1,
        statuses: [],
        types: [],
        showTransactionModal: false,
        showCreditModal: false
    };
    componentDidMount = () => setTimeout(this.fetchData, 200);
    fetchData = () => {
        this.fetchManagers();
        this.fetchCounterparties();
        this.fetchCredits();
        this.fetchOperations();
        this.fetchCompanies();
        this.fetchAccounts();
    }
    fetchAccounts = () => {
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    fetchCompanies = () => {
        agent.Company.getAll()
            .then(res => this.setState({ companiesLoaded: true, companies: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    fetchManagers = () => {
        agent.User.managers()
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    fetchOperations = () => {
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    fetchCounterparties = () => {
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    fetchCredits = () => {
        this.setState({ creditsLoaded: false });
        const { currentPage, sortedField, asc, searchQuery = "", statuses, types, startDate, endDate } = this.state;

        const criteria = Object.assign(
            { currentPage, sortedField, asc },
            statuses.length > 0 ? { statuses } : {},
            types.length > 0 ? { types } : {},
            startDate ? { startDate: startDate.valueOf() } : {},
            endDate ? { endDate: endDate.valueOf() } : {},
            searchQuery.length > 1 ? { searchQuery } : {}
        );

        agent.Credit.getAll(criteria)
            .then(res => this.setState({
                credits: res.credits,
                totalCredits: res.total,
                totalCreditsSum: res.totalSum,
                creditsLoaded: true
            }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    turnPage = (e, p) => this.setState({ currentPage: p }, () => this.fetchCredits());
    sortTable = (f) => {
        const { sortedField, asc } = this.state;
        this.setState({ sortedField: f, asc: sortedField === f ?  -1 * asc : asc }, () => this.fetchCredits());
    }
    throttledSearchCredits = throttle(() => this.fetchCredits(), 500)
    searchCredits = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query }, this.throttledSearchCredits)
    }
    clearSearch = () => {
        this.setState({ searchQuery: "" }, () => this.fetchCredits());
    }
    toggleStatus = (status) => {
        const { statuses } = this.state;
        this.setState({ currentPage: 0, statuses: statuses.includes(status) ? statuses.filter(s => s !== status) : statuses.concat(status) }, () => this.fetchCredits());
    }
    toggleType = (type) => {
        const { types } = this.state;
        this.setState({ currentPage: 0, types: types.includes(type) ? types.filter(t => t !== type) : types.concat(type) }, () => this.fetchCredits());
    }
    closeTransactionModal = () => this.setState({ showTransactionModal: false});
    openTransactionModal = (e) => {
        e.preventDefault();
        this.setState({ showTransactionModal: true })
    }
    closeCreditModal = () => this.setState({ showCreditModal: false});
    openCreditModal = (e) => {
        e.preventDefault();
        this.setState({ showCreditModal: true})
    }
    refreshTransactionData = t => {
        const { inputSum, dispatch } = this.props;
        this.setState({ transactions: t });
        const transactionsSum = t.reduce((p, n) => p + Number(`${n.sum}`.replace(/\s/g,``)), 0);

        dispatch(change("transaction-form", "sum", normalizeMoney(Math.max(inputSum - transactionsSum, 0))));
    }
    addTransaction = (data) => {
        const { transactions } = this.state;
        const updTransactions = transactions.concat(data);
        this.refreshTransactionData(updTransactions);
    }
    deleteTransaction = (index) => {
        const { transactions } = this.state;
        const updTransactions = transactions.filter((_, i) => i !== index);
        this.refreshTransactionData(updTransactions);
    }
    onCreditCreate = (data) => {
        const { transactions } = this.state;
        const { inputSide, dispatch } = this.props;
        const processedTransactions = transactions.map(t => Object.assign({...t}, {sum: {"DEBIT": 1, "CREDIT": -1}[inputSide] * Number(`${t.sum}`.replace(/\s/g,``))}));
        agent.Credit.create(data, processedTransactions)
            .then(() => {
                this.closeCreditModal();
                this.closeTransactionModal();
                dispatch({ type: MESSAGE_SENDED, payload: { text: "Успешно добавлено", type: "success" } });
                this.fetchCredits();
            })
            .catch(e => dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    onStartDateChange = date => this.setState({ startDate: new Date(date) }, () => this.fetchCredits());
    onEndDateChange = date => this.setState({ endDate: new Date(date) }, () => this.fetchCredits());

    render() {
        const { counterpartiesLoaded,
                counterparties,
                accountsLoaded,
                accounts,
                operationsLoaded,
                operations,
                companiesLoaded,
                companies,
                managersLoaded,
                managers,
                creditsLoaded,
                credits,
                transactions,
                totalCredits,
                currentPage,
                sortedField,
                startDate,
                endDate,
                searchQuery,
                asc,
                statuses,
                types,
                showTransactionModal,
                totalCreditsSum,
                showCreditModal } = this.state;

        const thead = {
            "date": "Дата",
            "prolongationDate": "Дата погашения",
            "number": "Номер",
            "manager": "Исполнитель",
            "company": "Компания",
            "type": "Тип",
            "counterparty": "Контрагент",
            "duration": "Срок",
            "sum": "Сумма",
            "rate": "Годовая ставка",
            "status": "Статус",
        };

        return (
            <React.Fragment>
                <Grid container justify="center" spacing={8} >
                    <Grid item>
                        <Grid container alignItems="center" justify="flex-start" spacing={8}>
                            <Grid item>
                                <Button onClick={this.openCreditModal} color="primary" variant="contained">Добавить</Button>
                                {showCreditModal &&
                                    <Dialog maxWidth={false} open={showCreditModal} onClose={this.closeCreditModal}>
                                        <Paper className="common-paper">
                                            <div className="common-column">
                                                <AddCreditForm companies={companies}
                                                               companiesLoaded={companiesLoaded}
                                                               counterparties={counterparties}
                                                               counterpartiesLoaded={counterpartiesLoaded}
                                                               accountsLoaded={accountsLoaded}
                                                               transactions={transactions}
                                                               accounts={accounts}
                                                               operationsLoaded={operationsLoaded}
                                                               operations={operations}
                                                               managersLoaded={managersLoaded}
                                                               managers={managers}
                                                               showModal={showTransactionModal}
                                                               addTransaction={this.addTransaction}
                                                               deleteTransaction={this.deleteTransaction}
                                                               onCreditCreate={this.onCreditCreate}
                                                               handleClose={this.closeTransactionModal}
                                                               handleClick={this.openTransactionModal} />
                                            </div>
                                        </Paper>
                                    </Dialog>
                                }
                            </Grid>
                            <Grid item>
                                <MaterialDatePicker label="Начало периода" value={startDate} onChange={this.onStartDateChange} />
                            </Grid>
                            <Grid item>
                                <MaterialDatePicker label="Конец периода" value={endDate} onChange={this.onEndDateChange} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item container alignItems="center" justify="center" spacing={8} xs>
                        {Object.keys(Credit.Statuses).map((s, i) =>
                            <Grid key={s} item>
                                <Button size="small"
                                        variant={statuses.includes(s) ? "outlined" : "contained"}
                                        onClick={() => this.toggleStatus(s)} >
                                    {Credit.Statuses[s]}
                                </Button>
                            </Grid>
                        )}
                        {Object.keys(Credit.Types).map((t, i) =>
                            <Grid key={t} item>
                                <Button size="small"
                                        variant={types.includes(t) ? "outlined" : "contained"}
                                        onClick={() => this.toggleType(t)} >
                                    {Credit.Types[t]}
                                </Button>
                            </Grid>
                        )}
                    </Grid>
                    <Grid item style={{ width: 250 }}>
                        <TextField label="Поиск"
                                   helperText="Введите номер займа, сумму или контрагента"
                                   fullWidth
                                   InputLabelProps={{ shrink: true }}
                                   FormHelperTextProps={{ classes: {root: "input-double-error"} }}
                                   value={searchQuery}
                                   onChange={this.searchCredits}
                                   InputProps={ searchQuery.length > 0 ? {
                                       endAdornment: (
                                           <InputAdornment position="end">
                                               <IconButton onClick={this.clearSearch}>
                                                    <HighlightOffIcon />
                                               </IconButton>
                                           </InputAdornment> )
                                   } : {} }
                                   variant="outlined"
                                   padding="dense"
                                   margin="dense" />
                    </Grid>
                </Grid>
                {creditsLoaded ?
                    credits.length > 0 ?
                        <Fade in={creditsLoaded}>
                            <Table padding="checkbox" className="m20">
                                <TableHead >
                                    <TableRow >
                                        {Object.keys(thead).map((th, i) => {
                                            return (
                                                <TableCell key={i} >
                                                    <TableSortLabel active={sortedField === th}
                                                                    direction={asc === 1 ? "asc" : "desc"}
                                                                    onClick={() => this.sortTable(th)} >
                                                        {thead[th]}
                                                    </TableSortLabel>
                                                </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                </TableHead>
                                <TableBody >
                                {credits.map(({ _id,
                                                date,
                                                prolongationDate,
                                                number,
                                                manager,
                                                type,
                                                side,
                                                company = {},
                                                counterparty,
                                                rate,
                                                duration,
                                                sum,
                                                status }, i) => {
                                    const [managerLastname] = ((manager||{}).fullname || "").split(" ");
                                    return (
                                        <TableRow key={i}>
                                            <TableCell >
                                                <FormattedDate value={date}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            </TableCell>
                                            <TableCell >
                                                <FormattedDate value={prolongationDate}
                                                               day="numeric"
                                                               month="numeric"
                                                               year="numeric" />
                                            </TableCell>
                                            <TableCell >
                                                 <InnerLink href={`/credit/${_id}`} label={("0".repeat(6) + number).slice(-6)} />
                                            </TableCell>
                                            <TableCell>
                                                <InnerLink href={`/user/${(manager||{})._id}`}
                                                           target="_blank"
                                                           label={`${managerLastname}`} />
                                            </TableCell>
                                            <TableCell>
                                                { (company || {}).name }
                                            </TableCell>
                                            <TableCell>
                                                {Credit.Types[type]}. {{"CREDIT": "Выдан", "DEBIT": "Привлечен"}[side]}
                                            </TableCell>
                                            <TableCell>
                                                { (counterparty || {}).name }
                                            </TableCell>
                                            <TableCell>
                                                { duration } дн.
                                            </TableCell>
                                            <TableCell>
                                                <FormattedNumber value={sum}
                                                                 style={`currency`}
                                                                 currency="RUB"
                                                                 minimumFractionDigits={0} />
                                            </TableCell>
                                            <TableCell>
                                                { rate } %
                                            </TableCell>
                                            <TableCell>
                                                { {"ACTIVE": "Активный", "CLOSED": "Закрыт"}[status] }
                                            </TableCell>
                                        </TableRow>
                                    )}
                                )}
                                {searchQuery.length > 0 &&
                                    <TableRow>
                                        <TableCell colSpan={8}>
                                            Итого:
                                        </TableCell>
                                        <TableCell>
                                            <FormattedNumber value={totalCreditsSum}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={0} />
                                        </TableCell>
                                        <TableCell colSpan={2}>
                                        </TableCell>
                                    </TableRow>
                                }
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TableCell colSpan={20}>
                                            <Grid container justify="center">
                                                <TablePagination count={totalCredits}
                                                                 labelDisplayedRows={({ from, to, count }) => `${from}-${to} из ${count}`}
                                                                 rowsPerPage={20}
                                                                 rowsPerPageOptions={[]}
                                                                 page={currentPage}
                                                                 onChangePage={this.turnPage}
                                                                 ActionsComponent={TablePaginationActions} />
                                            </Grid>
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </Fade>
                        :
                        <Typography>Записей не найдено</Typography>
                    :
                    <Preloader />
                }
            </React.Fragment>
        )
    }
}

export default connect(
    state => ({
        inputSide: formValueSelector("new-credit-form")(state, "side"),
        inputSum: Number(`${formValueSelector("new-credit-form")(state, "sum")}`.replace(/\s/g,``))
    }),
    null
)(Credits);



// WEBPACK FOOTER //
// ./src/components/Credits.js